import cx from 'clsx';
import { Tag } from '@kcd/design-system';

type Props = {
  color?: 'red' | 'green' | 'blue' | 'gray' | 'deepGray';
} & React.ComponentProps<typeof Tag>;

const colorType = {
  red: 'bg-red-100 text-red-600',
  green: 'bg-green-100 text-green-800',
  blue: 'bg-blue-100 text-blue-600',
  gray: 'bg-gray-100 text-gray-1000',
  deepGray: 'bg-secondary-air text-secondary-medium',
};

const ColorTag = ({ color = 'gray', className, ...props }: Props) => {
  return <Tag {...props} className={cx(colorType[color], className)} />;
};

export default ColorTag;
